<section class="px-lg-5 px-5 page-center-card">

    <div class="card bg-transparent text-center border-0">
        <i class="mdi mdi-account-cancel f-80 text-muted"></i>
        <h1 class="text-muted text-center f-30 mt-4 fw-300">USUÁRIO NÃO AUTORIZADO</h1>
        <p [style.maxWidth.px]="350" class="mx-auto mt-3 text-muted f-20 fw-300">
            Seu usuário não possui permissão para acessar a página
        </p>
    </div>

</section>